import { render, staticRenderFns } from "./CatBannerApp.vue?vue&type=template&id=1a4c7542&"
import script from "./CatBannerApp.vue?vue&type=script&lang=js&"
export * from "./CatBannerApp.vue?vue&type=script&lang=js&"
import style0 from "./CatBannerApp.vue?vue&type=style&index=0&id=1a4c7542&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports